import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ProductCarousel = () => {
  const { t } = useTranslation();
  const [selectedProduct, setSelectedProduct] = useState(null);

const products = [
  { 
    id: 6, 
    name: t('fine_disinfectant'), 
    image: "images/p6.webp", 
    description: t('fine_disinfectant_desc'),
  },
  { 
    id: 3, 
    name: t('fine_led_lamp'),
    image: "images/p3.webp", 
    description: t('fine_led_lamp_desc'), 
  },
  { 
    id: 7, 
    name: t('new_no1_detergent'),
    image: "images/p7.webp", 
    description: t('new_no1_detergent_desc'), 
  },
  { 
    id: 2, 
    name: t('mobi_3in1_floor'), 
    image: "images/p2.webp", 
    description: t('mobi_3in1_floor_desc'), 
  },
  { 
    id: 1, 
    name: t('mobi_lemon_dishwash'), 
    image: "images/p1.webp", 
    description: t('mobi_lemon_dishwash_desc'), 
  },
  { 
    id: 4, 
    name: t('mobi_furniture_polish'), 
    image: "images/p4.webp", 
    description:  t('mobi_furniture_polish_desc'), 
  },
  { 
    id: 5, 
    name: t('fine_gel_cleaner'), 
    image: "images/p5.webp", 
    description: t('fine_gel_cleaner_desc'), 
  }
];

  const ProductDialog = ({ product, onClose }) => (
    <div className="dialog-overlay">
      <div className="dialog-content">
        <button className="close-button" onClick={onClose}>×</button>
        <img src={product.image} alt={product.name} />
        <h2>{product.name}</h2>
        <p>{product.description}</p>
        <h3>{product.price}</h3>
      </div>
    </div>
  );

  return (
    <div className="carousel-wrapper">
      <div className="heading_container heading_center">
        <h1 className='fw-bold mb-5 text-secondary'>{t('best-seller')}</h1>
      </div>

      <div className="product-container">
        {products.map(product => (
          <div key={product.id} className="product-card">
            <img src={product.image} alt={product.name} className="product-image" />

            <div className="product-details">
              <h5>{product.name}</h5>
              <p className="price">{product.price}</p>

              <button className="view-more-btn" onClick={() => setSelectedProduct(product)}>
                {t('view-more')}
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedProduct && (
        <ProductDialog 
          product={selectedProduct} 
          onClose={() => setSelectedProduct(null)} 
        />
      )}
    </div>
  );
};

export default ProductCarousel;
